/** Helper methods for comparing email addresses */

/**
 * Addresses that differ only by case or surrounding whitespace are the same address, so
 * every comparison between two of them goes through here rather than comparing raw strings.
 */
export const normalizeEmail = (email?: string) =>
	email?.trim().toLowerCase() ?? ''
